import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { FinanceiroModel } from '../financeiro/financeiro-model';
import { ContasReceberModel } from '../models/contas-receber-model';
import { EmpresaModel } from '../models/empresa-model';
import { SetorModel } from '../models/setor-model';
import { Funcoes, Periodos } from '../services/funcoes';
import { Services } from '../services/servicos';
import { CarteiraModel } from './carteira-model';

@Component({
  selector: 'app-carteira',
  templateUrl: './carteira.component.html',
  styleUrls: ['./carteira.component.css']
})
export class CarteiraComponent implements OnInit {
  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  empresas: EmpresaModel[];
  selecionarEmpresa: EmpresaModel;

  origens: SetorModel[];
  selecionarOrigem: SetorModel;

  periodos: Periodos[];
  selecionarPeriodo: string;

  data_inicial: Date = new Date();
  data_final: Date = new Date();
  grafico: any;
  grafico_bar: any;

  lista: CarteiraModel[];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  loading: boolean = true;
  filtros: CarteiraModel = new CarteiraModel();

  //Total da Carteira
  listaGeral: CarteiraModel[];
  listaTotalCarteira: CarteiraModel[];
  totalTotalCarteira: number
  displayTotalCarteira: boolean;
  //Novos Clientes
  listaNovosClientes: CarteiraModel[];
  totalNovosClientes: number
  displayNovosClientes: boolean;
  //Clientes Cancelados	
  listaClientesCancelados: CarteiraModel[];
  totalClientesCancelados: number
  displayClientesCancelados: boolean;
  //FIM VARIÁVEIS

  //TOTAL ELEVS.
  listaTotalElev: CarteiraModel[];
  totalTotalElev: number
  displayTotalElev: boolean;

  //TOTAL VALOR
  listaTotalValor: CarteiraModel[];
  totalTotalValor: number
  displayTotalValor: boolean;

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    this.periodos = this.funcoes.Periodos;
    if (this.periodos.length > 0) {
      this.selecionaMesAtual();
    }
    //this.origens = this.funcoes.Origens;
  }

  selecionaMesAtual() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
    console.log(this.selecionarPeriodo);
    this.selecionaPeriodo(this.selecionarPeriodo);
  }

  ngOnInit(): void {

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO EMPRESAS
    try {
      this.service.listarEmpresas()
        .subscribe(data => {
          if (data.Success) {
            this.empresas = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS     

    //BUSCANDO SETOR
    try {
      this.service.listarSetor()
        .subscribe(data => {
          if (data.Success) {
            this.origens = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO SETOR     

    this.selecionaMesAtual();
    //PESQUISANDO AO ABRIR
    this.pesquisar();
  }


  pesquisar() {
    this.loading = true;

    this.filtros.filtro_data_inicial = this.data_inicial;
    this.filtros.filtro_data_final = this.data_final;
    this.filtros.setor = this.selecionarOrigem == null ? "" : this.selecionarOrigem.nome;
    this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;

    try {
      this.service.listarCarteira(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            this.updateChart(data.Response);

          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  onRowSelect(event) {

    try {
      this.service.listarCarteiraOrigem(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.listaGeral = data.Response;

            if (event.data.descricaoTitulo == "A - Total da Carteira") {
              this.displayTotalCarteira = true;
              this.listaTotalCarteira = this.listaGeral.filter(c => c.tem == "S");
              this.totalTotalCarteira = this.listaTotalCarteira.length;

              this.displayTotalValor = true;
              this.listaTotalValor = this.listaGeral.filter(c => c.tem == "S");
              this.totalTotalValor = this.listaTotalValor.length;
              this.calcularTotal();

              this.displayTotalElev = true;
              this.listaTotalElev = this.listaGeral.filter(c => c.tem == "S");
              this.totalTotalElev = this.listaTotalElev.length;
              this.calcularTotalElev();
            }
            else if (event.data.descricaoTitulo == "B - Novos Clientes") {
              this.displayNovosClientes = true;
              this.listaNovosClientes = this.listaGeral.filter(c => new Date(c.data_proposta) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data_proposta) <= new Date(this.filtros.filtro_data_final) && c.tem == "S");
              this.totalNovosClientes = this.listaNovosClientes.length;

              this.displayTotalValor = true;
              this.listaTotalValor = this.listaGeral.filter(c => new Date(c.data_proposta) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data_proposta) <= new Date(this.filtros.filtro_data_final) && c.tem == "S");
              this.totalTotalValor = this.listaTotalValor.length;
              this.calcularTotal();

              this.displayTotalElev = true;
              this.listaTotalElev = this.listaGeral.filter((c => new Date(c.data_proposta) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.data_proposta) <= new Date(this.filtros.filtro_data_final) && c.tem == "S"));
              this.totalTotalElev = this.listaTotalElev.length;
              this.calcularTotalElev(); 
            }
            else if (event.data.descricaoTitulo == "C - Clientes Cancelados") {
              this.displayClientesCancelados = true;
              this.listaClientesCancelados = this.listaGeral.filter(c => new Date(c.canc_cli) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.canc_cli) <= new Date(this.filtros.filtro_data_final) && c.tem == "N");
              this.totalClientesCancelados = this.listaClientesCancelados.length;

              this.displayTotalValor = true;
              this.listaTotalValor = this.listaGeral.filter(c => c.tem == "N");
              this.totalTotalValor = this.listaTotalValor.length;
              this.calcularTotal();

              this.displayTotalElev = true;
              this.listaTotalElev = this.listaGeral.filter(c => new Date(c.canc_cli) >= new Date(this.filtros.filtro_data_inicial) && new Date(c.canc_cli) <= new Date(this.filtros.filtro_data_final) && c.tem == "N");
              this.totalTotalElev = this.listaTotalElev.length;
              this.calcularTotalElev(); 
            }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  total_Total_Elev: number = 0;
  calcularTotalElev() {

    this.total_Total_Elev = this.listaTotalElev.filter(item => item.qtd, c => c.tem == "S")
      .reduce((sum, current) => sum + Number(current.qtd), 0) 

  }

  total_Total_Valor: number = 0;
  calcularTotal() {

    this.total_Total_Valor = this.listaTotalValor.filter(item => item.valor_contrato)
      .reduce((sum, current) => sum + Number(current.valor_contrato), 0)
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

  updateChart(chart: CarteiraModel[]) {

    this.grafico = {
      labels: [
        'B - Novos Clientes',
        'C - Clientes Cancelados'],
      datasets: [
        {
          data: [chart[1].valor_contrato, chart[2].valor_contrato],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
          ]
        }]
    };
  }

  onChangePeriodo(event) {
    if (event.value != null) {
      this.selecionaPeriodo(event.value);
      console.log(event);
    }
  }

  selecionaPeriodo(mes: string) {
    console.log('LOKOOOOO' + mes);
    if (mes == "Todos") {
      this.data_inicial = new Date(1950, 1, 1);
      this.data_final = new Date();
    }
    else if (mes == "3 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
      this.data_final = new Date();
      console.log((today.getDay() - 90));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "6 Meses") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
      this.data_final = new Date();
      console.log((today.getDay() - 180));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "9 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
      this.data_final = new Date();
      console.log((today.getDay() - 270));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "1 Ano") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
      this.data_final = new Date();
      console.log((today.getDay() - 365));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "Janeiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 0, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Fevereiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 1, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Março") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 2, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Abril") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 3, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Maio") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 4, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Junho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 5, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Julho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 6, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Agosto") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 7, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Setembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 8, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Outubro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 9, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Novembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 10, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Dezembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 11, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
  }

}
